export const paramNameOptions = {
    VIEW: 'view',
    MONTHLY: 'monthly',
    SPOTID: 'spot-id',
    OPERATOR_ID: 'operator_id',
    FACILITY: 'facility',
    DESTINATION_ID: 'destination_id',
    HIDE_EVENT_MODAL: 'hide_event_modal',
};
export function updateRouteParam(paramName, paramValue) {
    if (typeof window === 'undefined') {
        return null;
    }
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set(paramName, paramValue);
    window.history.replaceState({}, '', newUrl.href);
}
export function removeRouteParam(paramName) {
    if (typeof window === 'undefined') {
        return null;
    }
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete(paramName);
    window.history.replaceState({}, '', newUrl.href);
}
export function getRouteParam(paramName) {
    if (typeof window === 'undefined') {
        return null;
    }
    const newUrl = new URL(window.location.href);
    return newUrl.searchParams.get(paramName);
}
/**
 * Get URL parameter value by name from the current URL
 * @returns - Object with the URL parameter name and value or an empty object
 */
export function getUrlParamAsObject(param) {
    const urlParams = new URLSearchParams(window.location.search);
    const paramValue = urlParams.get(param);
    return paramValue ? { [param]: paramValue } : {};
}
